import { render, staticRenderFns } from "./TeamDashboardView.vue?vue&type=template&id=585ce8ce&"
import script from "./TeamDashboardView.vue?vue&type=script&lang=ts&"
export * from "./TeamDashboardView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports